'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCommunities = exports.getCommunityRouteProps = exports.getCommunity = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = require('babel-runtime/helpers/extends');

var _extends5 = _interopRequireDefault(_extends4);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _reselect = require('reselect');

var _fp = require('lodash/fp');

var _fp2 = _interopRequireDefault(_fp);

var _bdcoreNamedRoutes = require('@bd/bdcore-named-routes');

var _bdcoreUtilities = require('@bd/bdcore-utilities');

var _selectors = require('../Builder/selectors');

var _Filters = require('../Filters');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routeParamsToPropsMap = {
  communityName: 'name',
  communityMarketArea: {
    path: 'area',
    ignoreSingle: true,
    resolve: function resolve(state, name) {
      var area = (0, _selectors.getArea)(state, { name: name });

      return area ? area.name : undefined;
    }
  },
  communityMarketAreaMetro: {
    path: 'area',
    ignoreSingle: true,
    resolve: function resolve(state, name) {
      var areas = (0, _selectors.getAreas)(state);
      var area = _fp2.default.find({ name: name })(areas);

      if (area && !area.isMetro && area.parentMetro) {
        area = _fp2.default.find({ name: area.parentMetro })(areas);
      }

      return area ? area.name : undefined;
    }
  },
  communityMarketAreaSubMetro: {
    path: 'area',
    ignoreSingle: true,
    resolve: function resolve(state, name) {
      var area = (0, _selectors.getArea)(state, { name: name });

      return area ? area.name : undefined;
    }
  }
};

var getCommunity = exports.getCommunity = function getCommunity(_ref, _ref2) {
  var _ref$cloudData = _ref.cloudData;
  _ref$cloudData = _ref$cloudData === undefined ? {} : _ref$cloudData;
  var communities = _ref$cloudData.communities;
  var match = _ref2.match,
      _id = _ref2._id,
      _ref2$builderId = _ref2.builderId,
      builderId = _ref2$builderId === undefined ? _bdcoreUtilities.ConfigStore.getConfig('builder_id') : _ref2$builderId,
      searchUnpublished = _ref2.searchUnpublished;

  var limitedRouteParamsToPropsMap = (0, _keys2.default)(routeParamsToPropsMap).reduce(function (result, key) {
    var param = routeParamsToPropsMap[key];

    if (!param.ignoreSingle) {
      return (0, _extends5.default)({}, result, (0, _defineProperty3.default)({}, key, param));
    }

    return result;
  }, {});

  var limitMatchParams = (0, _keys2.default)(match ? match.params : {}).reduce(function (result, key) {
    if (_fp2.default.has(key, limitedRouteParamsToPropsMap)) {
      return (0, _extends5.default)({}, result, (0, _defineProperty3.default)({}, key, match.params[key]));
    }

    return result;
  }, {});

  var data = _fp2.default.getOr([], builderId + '.data', communities);
  if (searchUnpublished) {
    data = data.concat(_fp2.default.getOr([], builderId + '.unpublished', communities));
  }

  return data.reduce(function (result, item) {
    if (result === undefined && (_id !== undefined && item._id === _id || match && (0, _bdcoreNamedRoutes.paramsMatch)(limitMatchParams, limitedRouteParamsToPropsMap, item, true))) {
      return item;
    }

    return result;
  }, undefined);
};

var getCommunityRouteProps = exports.getCommunityRouteProps = function getCommunityRouteProps(community, state) {
  return (0, _bdcoreNamedRoutes.getPropsFromItem)(community, routeParamsToPropsMap, true, state);
};

var getCommunities = exports.getCommunities = (0, _reselect.createSelector)([function (state) {
  return state;
}, function (state, props, builderId) {
  return builderId;
}, function () {
  return _Filters.getFilterValues.apply(undefined, arguments);
}, function (_ref3, _ref4) {
  var _ref3$cloudData = _ref3.cloudData;
  _ref3$cloudData = _ref3$cloudData === undefined ? {} : _ref3$cloudData;
  var communities = _ref3$cloudData.communities;
  var _ref4$builderId = _ref4.builderId,
      builderId = _ref4$builderId === undefined ? _bdcoreUtilities.ConfigStore.getConfig('builder_id') : _ref4$builderId;
  return _fp2.default.getOr([], builderId + '.data', communities);
}], function (state, builderId, filters, communities) {
  return (0, _Filters.processFilters)(state, 'communities', communities, filters, builderId);
});
exports.default = getCommunity;


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-data/build/Communities/selectors.js
// module id = 152
// module chunks = 0